
import {Swiper} from 'swiper';
import {Navigation} from "swiper/modules";
import 'swiper/css';
document.querySelectorAll('[data-home-slider]').forEach((slider) => {

  const swiper = new Swiper(slider.querySelector('.swiper'), {
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 16,
    centeredSlides: false,
    modules: [Navigation],
    navigation: {
      nextEl: slider.querySelector('.page-home-related-next'),
    },
  });


})
